import { isValidObject, getObjectKeysSafely } from "./object"

export const arrayContainsFalse = (array: [boolean]) => array.includes(false)

export function isConsistentJSONArray(json: any[]): boolean {
    // Must be an array
    if (!Array.isArray(json)) return false

    const firstItem = json[0]

    // Item must be an object
    if (!isValidObject(firstItem)) return false

    const keys = getObjectKeysSafely(firstItem)
    if (!keys) return false

    return !arrayContainsFalse(
        json.map((item: object) => {
            // Item must be an object
            if (!isValidObject(item)) return false

            return !arrayContainsFalse(
                keys.map(key => item.hasOwnProperty(key)) as [boolean]
            )
        }) as [boolean]
    )
}
